import React from "react";
import LottieLoader from "components/containers/common/LottieLoader";
import {
  ModalSection,
  Modal,
  HeaderImgSection,
  HeaderImg,
  BodySection,
  ModalInfo,
  InfoTitle,
  InfoDescription,
  BtnDummySpace,
  BtnSection,
  LeftBtn,
  RightBtn,
} from "./style";

export default function ImageConfirmModal({
  dataList,
  onComplete,
  onCancel,
  lottieOptions,
}) {
  return (
    <ModalSection
      onClick={(e) => {
        if (e.currentTarget === e.target && onCancel) {
          onCancel();
        }
      }}
    >
      <Modal>
        <HeaderImgSection>
          <HeaderImg src={dataList["modalImg"]} />
        </HeaderImgSection>
        <BodySection>
          <ModalInfo>
            <InfoTitle>{dataList["title"]}</InfoTitle>
            <InfoDescription>{dataList["description"]}</InfoDescription>
          </ModalInfo>
          <BtnSection>
            <LeftBtn
              onClick={(e) => {
                if (onCancel) {
                  onCancel();
                }
              }}
            >
              {dataList["cancelText"]}
            </LeftBtn>
            <RightBtn
              onClick={(e) => {
                if (onComplete) {
                  onComplete();
                }
              }}
            >
              {dataList["completeText"]}
            </RightBtn>
          </BtnSection>
          <BtnDummySpace></BtnDummySpace>
        </BodySection>
      </Modal>
      {lottieOptions ? (
        <LottieLoader
          lottieOptions={lottieOptions}
          style={{ position: "absolute", top: "0" }}
        />
      ) : null}
    </ModalSection>
  );
}
